// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"card-links_wrapper__y2RTJ"};